import { AttachmentTile as AttachmentTileBase } from '@components/AttachmentTile'
import AttachmentTileOverlay from '@components/AttachmentTileOverlay'

import { getAttachmentType } from '@functions/attachment'

import useConversationContainer from '@hooks/useConversationContainer'

import type { AttachmentModel } from '@models/types'

import type { UseMediaReviewerOrderItemPayload } from '../../hooks/useMediaReviewerOrderItem'

import BulkAttachmentTileOverlay from '../BulkAttachmentTileOverlay'

interface AttachmentTileProps {
  attachment: AttachmentModel,
  index: number,
  isSelected: boolean,
  orderItemPayload: UseMediaReviewerOrderItemPayload,
}

const AttachmentTile = (props: AttachmentTileProps) => {
  const {
    attachment, index, isSelected, orderItemPayload,
  } = props

  const {
    bulkSelectMode,
    callbacks: {
      selectAttachment,
      toggleEntityId,
    },
    selectedEntityIds,
  } = orderItemPayload

  const { hasFilteredComments } = useConversationContainer({
    // @ts-expect-error TS2740
    conversation: { subject_id: attachment.id, subject_type: 'Attachment' },
    performHttpRequests: !!attachment.id,
  })

  const attachmentType = getAttachmentType(attachment)

  const selectAttachmentFn = bulkSelectMode
    ? () => toggleEntityId(attachment.id)
    : () => selectAttachment(index, hasFilteredComments)

  return (
    <AttachmentTileBase
      attachment={attachment}
      callbacks={{ selectAttachment: selectAttachmentFn }}
      disabled={bulkSelectMode && attachmentType !== 'image'}
      key={attachment.id}
      isSelected={isSelected}
    >
      {!bulkSelectMode && (
        <AttachmentTileOverlay
          attachment={attachment}
          hasFilteredComments={hasFilteredComments}
          key={attachment.id}
        />
      )}

      {attachmentType === 'image' && bulkSelectMode && (
        <BulkAttachmentTileOverlay
          key={attachment.id}
          isSelected={selectedEntityIds.includes(attachment.id)}
        />
      )}
    </AttachmentTileBase>
  )
}

export default AttachmentTile
